import { render, staticRenderFns } from "./OtevreneZakazky.vue?vue&type=template&id=13402cb4&"
import script from "./OtevreneZakazky.vue?vue&type=script&lang=ts&"
export * from "./OtevreneZakazky.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports